import React, {Component}  from 'react';
import { Switch, Route } from 'react-router-dom';
import { connect } from 'react-redux';

import SingleAthlete from './single';
import ListAthletes from './list';
import { getIsCurrentOrganizationPersonal } from 'shared_redux/selectors/view/organization_switcher';

class View extends Component {

    shouldComponentUpdate(nextProps) {
        return nextProps.isPersonal !== this.props.isPersonal;
    }

    render() {
        const { isPersonal } = this.props;
        return (
            <Switch>
                <Route path='/athletes/:athleteid/:athletename/:tab' component={SingleAthlete} />
                <Route path='/athletes/:athleteid/:athletename' component={SingleAthlete} />
                <Route path='/athletes/:athleteid' component={SingleAthlete} />
                <Route path='/athletes' component={isPersonal ? SingleAthlete : ListAthletes} />
            </Switch>
        );
    }
};

const mapStateToProps = (state) => ({
    isPersonal: getIsCurrentOrganizationPersonal(state),
});

export default connect(mapStateToProps)(View);
